import server from './server'

export const fetchBookingsListing = (pageNum = 1, filter = null) => {
  return server.get('/bookings.json', {
    params: { page: pageNum, filter: filter }
  })
}
export const cancelBooking = (id) => {
  return server.put(`/bookings/${id}/cancel`)
}
